import React, { useState } from 'react';
import { Text } from '@shopify/polaris';
import {Util, FormProvider} from '@thinkwell/react.common';
import {AppProvider } from '@thinkwell/react.polaris';
import EmailField from '../EmailField';
import ProxyForm from './ProxyForm';

export default function RecoverPassword(props) {
  const [successMessage, setSuccessMessage] = useState()

  const data = {form_type: "recover_customer_password"}

  Util.hideLoader()

  const onSuccess = (response) => {
    document.querySelector('#recover-password p.note').style.display = 'none'
    const message = "We have sent you an email with instructions on how to reset your password.\n" +
    "Please check your Inbox as well as your Promotions and Spam folders.\n" +
    "If you don't receive your password reset email within the next 10 minutes, please contact our support at support@thinkwell.com."
    setSuccessMessage(message)
  }

  const onError = (error) => {
    const noteEl = document.querySelector('#recover-password p.note')
    if (noteEl) {
      noteEl.style.display = 'none'
    }
    console.log('recover email shopify error : ', error);
  }

  const showLogin = () => {
    window.location.replace('/account/login?login');
  }

  if (props.error) {
    onError(props.error)
  }

  return (<AppProvider><FormProvider data={data}><div>
    { successMessage ? <Text as="span" color="success">{successMessage}</Text> :
      <ProxyForm xhr
      action="/account/recover"
      submitText="Submit"
      onSuccess={onSuccess}
      onError={onError}
      proxy={{action: '/accounts/recover_password', host: props.host, shop_name: props.shop_name}}
      bottomLink={{onClick: showLogin, text: "Cancel"}}
      error={props.error}>
        <input readOnly type="hidden" name="form_type" value="recover_customer_password" />
        <input readOnly type="hidden" name="utf8" value="✓" />
        <EmailField
          label="Email"
          id="recover-email"
          name="email"
          required
        />
      </ProxyForm>
    }
    </div></FormProvider></AppProvider>)
}
